// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"b56d3b33","237":"15cb61e8","404":"572277f5","435":"926a360f","564":"587e4951","627":"6deb7f04","828":"38491fc9","839":"7edc37c4"}[chunkId] + ".chunk.css";
};